import { ICellRendererParams } from '@ag-grid-community/core';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';
import { ToastType } from '@components/Toast';
import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import { ILoadBoardViewModel, loadBoardStore } from '@store/loadboard';
import { changeLoadStatus } from '@store/orders';
import { handleToast } from '@utils/utils';
import { getLoadColor } from '@views/order/components/header/constants';
import { Show } from 'solid-js';

const modeTypes = [
  { label: 'Assigned', value: 'Assigned' },
  { label: 'Can Get', value: 'Can Get' },
  { label: 'Unassigned', value: 'Unassigned' },
  { label: 'Dispatched', value: 'Dispatched' },
  { label: 'At Shipper', value: 'At Shipper' },
  { label: 'Loaded', value: 'Loaded' },
  { label: 'In Transit', value: 'In Transit' },
  { label: 'At Receiver', value: 'At Receiver' },
  { label: 'Out On Delivery', value: 'Out On Delivery' },
  { label: 'Empty', value: 'Empty' },
];

const LoadBoardStatusCell = (
  data: ICellRendererParams<ILoadBoardViewModel>,
) => {
  const isStatusEditRestricted = isFeatureFlagEnabled(
    FeatureFlags.perm_loadboard_restrict_status_edit,
  );

  const showReadOnlyStatus = () =>
    isStatusEditRestricted() &&
    (data.data?.mode === 'TL' || data.data?.mode === 'Partial');

  const onStatusChange = async (event: Event) => {
    const target = event.currentTarget;
    if (!(target instanceof HTMLSelectElement)) return;
    const value = target.value;
    const previousStatus = data.data?.status ?? '';
    try {
      if (data.data !== undefined) {
        const loadId = data.data.loadId;

        const succeeded = await changeLoadStatus(
          loadId,
          value,
          CHANGE_TRACKING_SOURCES.loadboard.statusChange,
        );
        if (!succeeded) {
          target.value = previousStatus;
          return;
        }
        if (
          loadBoardStore.onlyEmpty === false &&
          data.data.status === 'Empty'
        ) {
          data.api.applyTransaction({ remove: [data.data] });
        } else {
          data.api.applyTransaction({
            update: [{ ...data.data, status: value }],
          });
        }
      }
    } catch (error) {
      target.value = previousStatus;
      handleToast(ToastType.Error, 'Failed to update status');
    }
  };

  return (
    <Show when={data.data} fallback={<>{data.value}</>}>
      <Show
        when={showReadOnlyStatus()}
        fallback={
          <select
            class="w-full px-3 py-2 rounded-md focus:outline-none focus-visible:border-[#123b50] hover:border-[#123b50] hover:border-2"
            value={data.data?.status}
            onChange={onStatusChange}
            style={{ 'background-color': getLoadColor(data.data?.status) }}
          >
            {modeTypes.map((c) => (
              <option value={c.value}>{c.label}</option>
            ))}
          </select>
        }
      >
        {data.data?.status}
      </Show>
    </Show>
  );
};

export default LoadBoardStatusCell;
